import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable()
export class PolService {
  private dataUrl = Config.URL_BASE;

  constructor(private http: HttpClient) {
  }
  
 
  polCatalogo(filter: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/pol/catalogo';
    url_ = url_.replace(/[?&]$/, '');

    return this.http.post(url_, filter).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  polizaCierreEjercicio(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/pol/poliza/cierre/ejercicio';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  polizaCierrePeriodo(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/pol/poliza/cierre/periodo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getDatosCierre(id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbConfEmp/get/periodo/cierre/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  validarCuentaSeleccionada(ctb_cta_id: number, gral_emp_id: number): Observable<any> {
    let url_ = this.dataUrl + '/pol/get/val/pol/' + ctb_cta_id + '/' + gral_emp_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

    getMonByEmpId(id: number): Observable<any> {
      let url_ = this.dataUrl + '/gralmon/get/byEmp/' + id;
      url_ = url_.replace(/[?&]$/, '');
      return this.http.get(url_).pipe(
        catchError(e => {
          console.log(e);
          return throwError(e);
        })
      );
    }

  polDelete(idPol: number, idGralUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/pol/delete/' + idPol + '/' + idGralUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getReporteXml(idEmp: number, mes: number, anio: number, tipoEnvio: String, num: String): Observable<any> {
    const url_ = this.dataUrl + '/pol/get/reporte/poliza/periodo/xml/' + idEmp + '/' + mes + '/' + anio + '/' + tipoEnvio + '/' + num;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getFormatoAspel(idEmp: number,ctb_tpol_id: number, year: number, month: number, day: number): Observable<any> {
    const url_ = this.dataUrl + '/reporte/documento/aspel/xlsx/' + idEmp + '/' + ctb_tpol_id + '/' + year + '/' + month + '/' + day;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  polGet(id: number): Observable<any> {
    let url_ = this.dataUrl + '/pol/get/{id}';
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  tpolGrupoGet(idEmp: number): Observable<any> {
    let url_ = this.dataUrl + '/tpol/get/grupo/lista/' + idEmp;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  tpolGet(idEmp: number): Observable<any> {
    let url_ = this.dataUrl + '/tpol/get/lista/' + idEmp;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  polPost(dto: any, idUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/pol/post/' + idUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  postBusqueda(criteria: any): Observable<any> {
    let url_ = this.dataUrl + '/cta/get/busqueda';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criteria).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getByCuentaAndEmp(cuenta: string, gral_emp_id: number): Observable<any> {
    let url_ = this.dataUrl + '/cta/getByCuentaAndEmp/' + cuenta + '/' + gral_emp_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getSucursalByIdEmp( gral_emp_id: number): Observable<any> {
    let url_ = this.dataUrl + '/gralsuc/get/byEmp/' + gral_emp_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  polPut(dto: any, idUsr: number): Observable<any> {
    let url_ = this.dataUrl + '/pol/put/' + idUsr;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }



  ctb_genera_poliza_cancelacion(_gral_usr_id: number,_empresa_id: number, _ctb_pol_id: number, _ctb_tpol_id: number,poliza_fecha: String): Observable<any> {
    const url_ = 
    this.dataUrl + '/pol/ctb_genera_poliza_cancelacion/' + _gral_usr_id + '/' + _empresa_id + '/' + _ctb_pol_id + '/' + _ctb_tpol_id + '/' + poliza_fecha;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }



  
    getCtbPolConf(gral_emp_id: number): Observable<any> {
      let url_ = this.dataUrl + '/ctb_pol_conf/list/' + gral_emp_id;
      url_ = url_.replace(/[?&]$/, '');
      return this.http.get(url_).pipe(
        catchError(e => {
          console.log(e);
          return throwError(e);
        })
      );
    }

}

export class CtbPolDto {
  id: number;
  empId: number | undefined = 0;
  add_doc_id: number[] = [];
  sucId: number;
  folio: String| undefined = '';
  tpolId: number | undefined = 0;
  ctbPolDet: CtbPolDet[] | undefined = [];
  ctb_con_id: number;
  concepto: String | undefined = '';
  ano: number | undefined = 0;
  mes: number | undefined = 0;
  fecha: String| undefined = '';
  monId: number | undefined = 0;
  moneda: String | undefined = '';
  modulo_origen: number;
  estatus: number | undefined = 1;
  cancelado: boolean | undefined = false;
  borrado_logico: boolean | undefined = false;
  credito: boolean | undefined = false;
  dias_credito: number | undefined = 0;
  fecha_ven_cre: String;
  poliza_ajuste: boolean | undefined = false;
  fecha_ajuste: String| undefined = '';
}
export class CtbTpolDto {
  id: number;
  titulo: String = '';
}
export class CtbPolDet {
  id: number;
  ctbPolId: number;
  ctbCta: CtbCtaDto = new CtbCtaDto();
  cargo: number | undefined = 0;
  abono: number | undefined = 0;
  num_mov: number | undefined = 0;
  referencia: string | undefined = '';
  concepto: string | undefined = '';
  ctbPolDetCc: any[] | undefined = [];
}
export class CtbCtaDto {
  id: number;
  cuenta: String;
  nombre: String;
  req_cc: boolean = false;
  naturaleza: number;
}
export class GralMonDto {
  id: number;
  claveS: String | undefined = '';
}
export class PageBusquedaObject {
  column?: string | undefined = '';
  criteriaSearch?: any | undefined = {};
  itemsPerPage?: number | undefined = 10;
  order?: string | undefined = '';
  pageNumber?: number = 1;
  sort?: boolean | undefined = false;
  page1?: boolean | undefined = false;
}
